export default class Accordion {
    constructor() {
        this.init()
    }

    init() {
        this.accordion()
    }

    accordion() {
        let question = document.querySelectorAll('.accordion__title')
    
        question.forEach((item, index) => {
            let container = item.parentElement
            // if (index == 0) {
            //     this.open(container)
            // }
    
            item.addEventListener('click', () => {
                let wrapper = container.parentElement
                if (container.classList.contains('is-active') ) {
                    this.close(container)
                } else {
                    let active = wrapper.querySelector('.is-active');
                    this.open(container)
    
                    if (active) {
                        this.close(active)
                    }
                }
            })
        });
    }
    
    close(item) {
        let answer = item.querySelector('.accordion__answer')
        let answerContentHeight = answer.querySelector('.accordion__answerInner').offsetHeight
        answer.style.maxHeight = answerContentHeight + 'px'
        setTimeout(() => {
            item.classList.remove('is-active')
            answer.style.maxHeight = 0
        }, 10)
    }

    open(item) {
        let answer = item.querySelector('.accordion__answer')
        let answerContentHeight = answer.querySelector('.accordion__answerInner').offsetHeight
    
        answer.style.maxHeight = answerContentHeight + 'px'
        item.classList.add('is-active')
        setTimeout(() => {
            answer.style.removeProperty('max-height')
        }, 700)
    }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/accordion.js
// module id = 6
// module chunks = 0